import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import xianheLogo2 from "../Components/Assets/newlogo.png";

function Partner() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) {
      setError("Please enter email and password");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/User/PartnerLogin?username=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (data.successful && data.Message === "Login successful") {
        // Store CustId if needed
        localStorage.setItem("partnerCustId", data.CustId);
        // Kept so the dashboard can call GetProfile, which needs the username
        localStorage.setItem("partnerUserName", email);
        navigate("/mainmaster");
      } else {
        setError(data.Message || "Invalid credentials");
      }
    } catch (err) {
      setError("Login failed. Please try again.");
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", backgroundColor: "#272725" }}>
      <button
        type="button"
        onClick={() => navigate("/main")}
        style={{
          position: "absolute",
          top: 16,
          left: 16,
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: "8px 14px",
          background: "transparent",
          color: "#DFBD69",
          border: "1px solid #DFBD69",
          borderRadius: 6,
          cursor: "pointer",
          fontSize: 14,
        }}
      >
        ← Back to main menu
      </button>
      {/* <img
        src={xianheLogo2}
        alt="Xianhe Logo"
        style={{ position: "absolute", top: 20, right: 24, height: 64 }}
      />  */}
      <form onSubmit={handleSubmit} style={{ width: 340, padding: 24, border: "1px solid #DFBD69", borderRadius: 8, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
        <h2 style={{ marginBottom: 16, color: "#DFBD69" }}>Partner Login</h2>
        {error && <div style={{ color: "#c00", marginBottom: 12 }}>{error}</div>}

        <label style={{ display: "block", marginBottom: 8, fontSize: 14, color: "#DFBD69" }}>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ 
                width: "100%", 
                padding: 8, 
                marginTop: 6, 
                boxSizing: "border-box", 
                backgroundColor: "#272725", 
                color: "#DFBD69",
                border: "1px solid #DFBD69",
                outline: "none"
              }}
              required
              disabled={loading}
            />
        </label>

        <label style={{ display: "block", marginTop: 12, fontSize: 14, color: "#DFBD69" }}>
            Password
            <div style={{ position: "relative", marginTop: 6 }}>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: "100%",
                  padding: 8,
                  paddingRight: 36,
                  boxSizing: "border-box",
                  backgroundColor: "#272725",
                  color: "#DFBD69",
                  border: "1px solid #DFBD69",
                  outline: "none"
                }}
                required
                disabled={loading}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#DFBD69",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
        </label>

        <button 
          type="submit" 
          style={{ 
            marginTop: 18, 
            width: "100%", 
            padding: 10, 
            background: loading ? "#999" : "#DFBD69", 
            color: "#272725", 
            border: "none", 
            borderRadius: 4,
            cursor: loading ? "not-allowed" : "pointer"
          }}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}

export default Partner;